import { IconProps } from '.';

const ThreeDIcon = ({
  color = 'var(--color-ui-icon-primary)',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 32 38"
      fill="none"
      {...rest}
      className={customClasses}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.4193 9.95144L16.0026 0.882812L0.585938 9.95144V28.048L16.0026 37.1166L31.4193 28.048V9.95144ZM3.08594 26.6181V11.3813L16.0026 3.78327L28.9193 11.3813V26.6181L16.0026 34.2161L3.08594 26.6181ZM7.27865 15.5115L14.9644 19.7387V28.1662H17.4644V19.7387L25.1501 15.5115L23.9453 13.321L16.2144 17.573L8.48344 13.321L7.27865 15.5115Z"
        fill={color}
      />
    </svg>
  );
};

export default ThreeDIcon;
